
document.addEventListener('DOMContentLoaded', () => {
    const collections = document.getElementById('Collections');

  if (!collections) return; // 要素が存在しない場合は何もしない
  
    // すべてのボタンを取得
    const buttons = document.querySelectorAll('.collections-controls__buttons button');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            // ボタンの data-class 属性からクラス名を取得
            const targetClass = button.getAttribute('data-class');

            // 現在のリストタイプクラスを削除
            collections.classList.remove('list-type-thin', 'list-type-middle', 'list-type-wide');

            // すべてのボタンから isActive クラスを削除
            buttons.forEach(btn => btn.classList.remove('isActive'));

            // 対象のクラスを追加
            collections.classList.add(targetClass);

            // 押されたボタンに isActive クラスを追加
            button.classList.add('isActive');
        });
    });
});
document.addEventListener('DOMContentLoaded', () => {
    const selectBox = document.querySelector('.list-type-selector');
    const listItems = document.querySelectorAll('.collections__item');

    if (!selectBox) return; // 要素が存在しない場合は何もしない
  
    selectBox.addEventListener('change', () => {
        const selectedValue = selectBox.value;

        listItems.forEach(item => {
            // ALLが選択された場合、すべて表示
            if (selectedValue === 'ALL') {
                item.style.display = '';
            } else {
                // data-categoryの値が選択されたvalueと一致するものだけ表示
                const category = item.getAttribute('data-category');
                if (category && category.includes(selectedValue)) {
                    item.style.display = '';
                } else {
                    item.style.display = 'none';
                }
            }
        });
    });
});

  function initializeCountdown(selector) {
    const parentElements = document.querySelectorAll(selector);

    if (parentElements.length === 0) return;

    const JAPAN_TIME_OFFSET = 9 * 60; // 日本時間（UTC+9）の分単位のオフセット
    const localOffset = -new Date().getTimezoneOffset(); // ローカルのオフセット（分）
    const timezoneDiff = (JAPAN_TIME_OFFSET - localOffset) * 60; // 秒単位の差分

    const formatTime = (days, hours, minutes, seconds) => {
        return `${days}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} LEFT`;
    };

    const updateCountdown = () => {
        const nowTimestamp = Math.floor(Date.now() / 1000);

        parentElements.forEach(parentElement => {
            const countdownElements = parentElement.querySelectorAll('.count[data-leftdate]');

            countdownElements.forEach(countdownElement => {
                const leftTimestamp = parseInt(countdownElement.getAttribute('data-leftdate'), 10);
                const startdate = countdownElement.getAttribute('data-text');

                if (isNaN(leftTimestamp)) {
                    console.error(`Invalid data-leftdate for element:`, countdownElement);
                    countdownElement.textContent = "ERROR";
                    return;
                }

                // 時差を補正
                const adjustedTimestamp = leftTimestamp - timezoneDiff;

                const diff = adjustedTimestamp - nowTimestamp;

                if (diff <= 0) {
                    countdownElement.textContent = startdate;
                    parentElement.classList.add('isFinish');
                    return;
                }

                const days = Math.floor(diff / (60 * 60 * 24));
                const hours = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
                const minutes = Math.floor((diff % (60 * 60)) / 60);
                const seconds = diff % 60;

                countdownElement.textContent = formatTime(days, hours, minutes, seconds);
            });
        });
    };

    updateCountdown();

    let intervalId = setInterval(() => {
        updateCountdown(); // 先にカウントダウンを更新

        const allEnded = Array.from(parentElements).every(parentElement => {
            const countdownElements = parentElement.querySelectorAll('.count[data-leftdate]');

            return Array.from(countdownElements).every(countdownElement => {
                const leftTimestamp = parseInt(countdownElement.getAttribute('data-leftdate'), 10);
                const adjustedTimestamp = leftTimestamp - timezoneDiff;
                const diff = adjustedTimestamp - Math.floor(Date.now() / 1000);
                return diff <= 0;
            });
        });

        if (allEnded) {
            clearInterval(intervalId);
        }
    }, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
    initializeCountdown('.tf-count');
});

//swiper
let swiperInstance = null; // Swiperインスタンスを管理する変数

function init() {
    if (window.innerWidth >= 900) {
        // Swiper
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null; // インスタンスをリセット
        }
        adjustContentPosition();
    } else {
        // Swiperが未初期化の場合のみ新しいインスタンスを作成
        if (!swiperInstance) {
            swiperInstance = new Swiper('.swiper', {
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    slideChangeTransitionStart: function () {
                        document.querySelectorAll('.slider-caption').forEach(caption => {
                            caption.style.opacity = 0; // 全キャプションを非表示
                        });
                        const activeSlide = document.querySelector('.swiper-slide-active .slider-caption');
                        if (activeSlide) {
                            activeSlide.style.opacity = 1; // アクティブスライドのキャプションを表示
                        }
                    },
                },
            });
        }
    }
}

// for product detail
function adjustContentPosition() {
    // .product-detail要素を取得
    const productDetail = document.getElementById('JS-Product-Detail');
    
    if (!productDetail) return; // 要素が存在しない場合は何もしない
    
    // .product-detailの高さを取得
    const contentHeight = productDetail.offsetHeight;
    // ブラウザの表示領域の高さを取得
    const viewportHeight = window.innerHeight;
    
    // 高さの比較とスタイルの適用
    if (contentHeight > viewportHeight) {
        const newTop = viewportHeight - contentHeight;
        productDetail.style.top = `${newTop}px`; // インラインCSSでtopを設定
    } else {
        productDetail.style.top = ''; // 条件を満たさない場合はリセット
    }
}

// 初期チェック
window.addEventListener('load', init);

// リサイズ時のパフォーマンス向上（debounceを適用）
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(init, 200); // 200msの遅延で実行
});


// ---------------------------------------------------------
// variation select menu

document.addEventListener("DOMContentLoaded", function() {
    const variationOpener = document.getElementById("VariationOpener");
    const variationSelectorMenu = document.getElementById("VariationSelector");

  if (!variationOpener || !variationSelectorMenu) return; // 要素が存在しない場合は何もしない
  
    // メニューを開閉する関数
    function toggleVariationSelector() {
        variationSelectorMenu.classList.toggle("open");  // openクラスを付与/削除

        if (variationSelectorMenu.classList.contains("open")) {
            document.body.classList.add("drawer-open");  // スクロールを無効化
        } else {
            document.body.classList.remove("drawer-open");  // スクロールを有効化
        }
    }
    
    // メニューオープナーにクリックイベントを追加
  if(variationOpener){
    variationOpener.addEventListener("click", toggleVariationSelector);
  }
    
    // ドロワーメニュー内の「閉じる」ボタンにイベントリスナーを追加
    const closeButton = document.getElementById("VariationClose");
    if (closeButton) {
        closeButton.addEventListener("click", toggleVariationSelector);
    }
});

// ---------------------------------------------------------
// Photo List

document.addEventListener("DOMContentLoaded", function() {
    const PhotoListOpener = document.getElementById("PhotoListOpener");
    const PhotoListBody = document.getElementById("Product-PhotoList");

  if (!PhotoListOpener || !PhotoListBody) return; // 要素が存在しない場合は何もしない
  
    // メニューを開閉する関数
    function togglePhotoList() {
        PhotoListBody.classList.toggle("open");  // openクラスを付与/削除

        if (PhotoListBody.classList.contains("open")) {
            document.body.classList.add("drawer-open");  // スクロールを無効化
        } else {
            document.body.classList.remove("drawer-open");  // スクロールを有効化
        }
    }
    
    // メニューオープナーにクリックイベントを追加
    PhotoListOpener.addEventListener("click", togglePhotoList);
    
    // ドロワーメニュー内の「閉じる」ボタンにイベントリスナーを追加
    const closeButton = document.getElementById("PhotoListClose");
    if (closeButton) {
        closeButton.addEventListener("click", togglePhotoList);
    }
});